<template>
    <div>
        <crud-facecade
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            dialogWidth="80%"
            :addButton="{ permission: 'default' }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @LoadCollectVideos="LoadCollectVideos"
        >
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BoardVideoSetting`,
    props: {},
    data() {
        return {
            title: `大屏视频播放设置`,
            url: {
                baseURL: `/api/AcisSystem/BoardScreenConfig`,
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row, `post`)
                },
                put: row => {
                    return this.saveOne(row, `put`)
                } },
            buttons: [],
            videocheckedRow: [],
            currentItem: {
                id: 0,
                title: ``
            },
            videosoption: []
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `board_ip`,
                    label: `IP`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 8,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `screen_type_enum`,
                    label: `屏幕类型`,
                    width: `150`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    colspan: 8,
                    options: this.sys_enums.EnumScreenType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `width`,
                    label: `宽`,
                    width: `150`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true,
                    colspan: 8,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `height`,
                    label: `高`,
                    width: `150`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true,
                    colspan: 8,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `x_axis`,
                    label: `x坐标`,
                    width: `150`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true,
                    colspan: 8,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `y_axis`,
                    label: `y坐标`,
                    width: `150`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true,
                    colspan: 8,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `textarea`,
                    prop: `description`,
                    label: `描述`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 8,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `enabled`,
                    label: `是否启用`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `enum_bool`,
                    colspan: 8,
                    default: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `200`,
                    readonly: false,
                    fixed: `right`,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default` // user:assignRole
                        },
                        // {
                        //     class: `is-plain`,
                        //     label: `视频列表`,
                        //     type: `primary`,
                        //     emit: `LoadCollectVideos`,
                        //     permission: `default` // user:assignRole
                        // },
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteData`,
                            permission: `default` // user:assignRole
                        }
                    ]
                },
                {
                    type: `table`,
                    prop: `extraOptionList`,
                    label: `空闲时间段`,
                    isEditable: true,
                    isCreatable: true,
                    options: [

                        {
                            type: `time`,
                            prop: `startTime`,
                            label: `开始时间`,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `time`,
                            prop: `endTime`,
                            label: `结束时间`,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `isshowvedio`,
                            label: `视频播放`,
                            options: `enum_bool`,
                            default: true,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `isshowboard`,
                            label: `大屏显示`,
                            options: `enum_bool`,
                            default: true,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `multiselect`,
                            prop: `week`,
                            label: `时间周期`,
                            showCount: 3,
                            options: [{ label: `周一`, value: `1` }, { label: `周二`, value: `2` }, { label: `周三`, value: `3` }, { label: `周四`, value: `4` }, { label: `周五`, value: `5` }, { label: `周六`, value: `6` }, { label: `周日`, value: `0` }],
                            default: false,
                            readonly: false,
                            isListable: true,
                            config: {
                                collapseTags: false
                            }
                        }
                    ],
                    colspan: 24,
                    default: []
                }, {
                    type: `table`,
                    prop: `videoInfoList`,
                    label: `视频列表`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `编号`,
                            width: `80`,
                            isKey: true,
                            isListable: true
                        },

                        {
                            type: `remoteselect`,
                            prop: `file_name`,
                            label: `名称`,
                            options: `/api/AcisSystem/BoardVideoInfo/Search`,
                            readonly: false,
                            isListable: true,
                            change: (that, { row }) => {
                                console.log(row)
                                if (row.file_name && row.file_name.label && row.file_name.value) {
                                    this.$set(row, `file_address`, row.file_name.jianpin)
                                }
                            }
                        },
                        {
                            type: `string`,
                            prop: `file_address`,
                            label: `地址`,
                            readonly: true,
                            isListable: true
                        },
                        {
                            type: `datetime`,
                            prop: `config_effective_date`,
                            label: `生效时间`,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `datetime`,
                            prop: `config_expiry_date`,
                            label: `过期时间`,
                            readonly: false,
                            isListable: true
                        },
                        {
                            type: `number`,
                            prop: `config_display_order`,
                            label: `排序号`,
                            readonly: false,
                            isListable: true
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
        }
    },
    mounted() {
    },
    methods: {
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardScreenConfig/Get/${row.id}`)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        saveOne(row, tp) {
            return new Promise((resolve, reject) => {
                console.log(row)
                var obj = row
                _.map(obj.extraOptionList, (d, index) => {
                    if (d.startTime == `` || d.startTime == null || d.startTime == undefined) {
                        this.$message.error(`空闲时间段开始时间不能为空！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.endTime == `` || d.endTime == null || d.endTime == undefined) {
                        this.$message.error(`空闲时间段结束时间不能为空！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.week == null || d.week == undefined || d.week.lenght == 0) {
                        this.$message.error(`空闲时间段时间周期不能为空！`)
                        throw new Error(`EndIterative`)
                    }
                    let startTime = this.$moment(d.startTime).format(`HH:mm`)
                    let endTime = this.$moment(d.endTime).format(`HH:mm`)
                    if (startTime > endTime) {
                        this.$message.error(`空闲时间段开始时间不能在结束时间之后！`)
                        throw new Error(`EndIterative`)
                    }
                })
                _.map(obj.videoInfoList, (d, index) => {
                    if (d.config_effective_date == `` || d.config_effective_date == null || d.config_effective_date == undefined) {
                        this.$message.error(`视频列表生效时间不能为空！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.config_expiry_date == `` || d.config_expiry_date == null || d.config_expiry_date == undefined) {
                        this.$message.error(`视频列表失效时间不能为空！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.file_address == `` || d.file_address == null || d.file_address == undefined) {
                        this.$message.error(`视频列表视频名称不能为空！`)
                        throw new Error(`EndIterative`)
                    }
                    let startTime = this.$moment(d.config_effective_date).format(`YYYY/MM/DD HH:mm`)
                    let endTime = this.$moment(d.config_expiry_date).format(`YYYY/MM/DD HH:mm`)
                    if (startTime > endTime) {
                        this.$message.error(`视频列表生效时间不能在失效时间之后！`)
                        throw new Error(`EndIterative`)
                    }
                })
                let r = _.map(obj.videoInfoList, (d, index) => {
                    if (typeof d.file_name == `object`) {
                        d.id = d.file_name.value
                        d.file_name = d.file_name.label
                    }
                    return d
                })
                obj.videoInfoList = r
                let req = this.myaxios[tp](`/api/AcisSystem/BoardScreenConfig/${tp}`, obj)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        selectionChange({ row }) {
            this.videocheckedRow = row
        },
        LoadCollectVideos() {
            this.collectVideos.datalist = []
            this.collectVideos.dialogFormVisible = true
            // 加载
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/BoardScreenConfig/Get`)
                req.then(data => {
                    console.log(data)
                    this.collectVideos.datalist = data.boardConfigVideosList
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        addVideoToList() {
            console.log(this.videocheckedRow)
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BoardVideoSetting/BoardVideoSetting.vue